import { createIntl, createIntlCache } from 'react-intl';
import renderLocale from '../helpers/renderLocale';
import messages from '../../assets/messages';
import User from './User';
import DISTANCE_UNIT from '../types/distanceUnits';
import { formatNumber } from '../utils/localization';

const locale = renderLocale();
const intl = createIntl(
  { locale, messages: messages[locale] },
  createIntlCache()
);

const labels = {
  noQuoteAvailable: intl.formatMessage({ id: 'vdp.overview.rateInfo.noQuote' }),
  promoRateInfo: intl.formatMessage({
    id: 'vdp.overview.rateInfo.promoRateInfo'
  }),
  rateInfo: intl.formatMessage({ id: 'vdp.overview.rateInfo.rateInfo' })
};

class Shipping {
  isShippingPromotion;

  shippingQuoteFormatted;

  distance;

  deliveryAddress;

  constructor(shippingEstimate, countryId) {
    this.distance = Shipping.formatDistance(
      shippingEstimate?.distance,
      countryId
    );
    this.shippingQuoteFormatted = Shipping.getShippingQuoteFormatted(
      shippingEstimate
    );
    this.isShippingPromotion = Shipping.isShippingPromotion(shippingEstimate);
    this.deliveryAddress = Shipping.formatDeliveryAddress(
      shippingEstimate?.deliveryAddress
    );
  }

  static isShippingPromotion(shippingQuote): boolean {
    if (shippingQuote?.isShippingPromotion) {
      return shippingQuote.isShippingPromotion;
    }

    return false;
  }

  // TODO Verify with product when this is enabled
  static getShippingQuoteFormatted(shippingEstimate): string {
    const hasShippingQuote = shippingEstimate?.amount;

    return hasShippingQuote
      ? Shipping.formatShippingQuote(shippingEstimate?.amount)
      : labels.noQuoteAvailable;
  }

  static formatTermsAndConditons(
    termsAndConditions: any,
    isShippingPromotion: boolean
  ) {
    if (!termsAndConditions) {
      return null;
    }

    const LINE_SEPARATOR = /\u2028/g;

    return {
      heading: isShippingPromotion ? labels.promoRateInfo : labels.rateInfo,
      title: termsAndConditions?.title,
      message: termsAndConditions?.body?.replace(LINE_SEPARATOR, ' '),
      disclaimer: termsAndConditions?.disclaimer,
      isShippingPromotion
    };
  }

  static formatShippingQuote(estimate) {
    const amount = estimate.split('.')[0];

    return amount === '$0' || amount === null
      ? labels.noQuoteAvailable
      : amount;
  }

  static formatDistance(distance, countryId) {
    const odometer = User.isCountryCanada(countryId)
      ? DISTANCE_UNIT.KM
      : DISTANCE_UNIT.MI;

    let retDistance = distance === null ? '- ' : distance;

    // Convert to miles if country not CA as backend returns distance in KM always
    if (!User.isCountryCanada(countryId) && retDistance !== '- ') {
      retDistance = formatNumber(
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        },
        retDistance * 0.621371
      );
    } else if (Number.isInteger(retDistance)) {
      retDistance = formatNumber(
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        },
        retDistance
      );
    }

    return `${retDistance} ${odometer}`;
  }

  static formatDeliveryAddress(deliveryAddress: string) {
    if (!deliveryAddress) {
      return null;
    }

    const parsedAddress = deliveryAddress.split(',');

    return {
      deliveryAddress: {
        street: parsedAddress[0],
        city: parsedAddress[1],
        province: parsedAddress[2],
        postalCode: parsedAddress[4]
      }
    };
  }
}

export default Shipping;
